import React, { useState, useEffect, Fragment } from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";
import Host from "../../Components/Host";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneIcon from "@mui/icons-material/Phone";
import HelmetComponent from "../../Components/HelmetComponent";

function AboutUs() {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, []);

  return (
    <>
      <HelmetComponent title={"About Us"} metaTitle={Host?.metaTitle} />
      <div className="statisc-page">
        <div className="container static-container">
          <div className="row static-row">
            <div className="col-md-10">
              <div
                className="static-container-card"
                style={{
                  textAlign: "left",
                  padding: "20px",
                  background: "#fcfcfc",
                  border: "1px solid #eee",
                  borderRadius: "7px",
                }}
              >
                <h1 style={{ padding: "20px 0px 20px 0px", fontWeight: 300, fontSize: "1.4rem" }}>{t("about_us")}</h1>

                <p>Welcome to {Host?.domainName}.</p>
                <p>
                  {Host?.domainName} is an e-commerce store based in Dubai, United Arab Emirates, operated by{" "}
                  {Host?.domainName} G LLC FZ.
                </p>
                <p>
                  We offer a wide range of products across categories such as electronics, fashion, beauty, lifestyle,
                  home essentials, accessories, and more. Our goal is to make online shopping simple, secure, and
                  convenient by providing customers with competitive prices, reliable delivery, and helpful customer
                  support.
                </p>
                <p>
                  At {Host?.domainName}, we work to ensure that product information, pricing, availability, delivery
                  timelines, and customer support are clear and easy to understand. We also provide secure payment
                  options and delivery services through trusted logistics partners.
                </p>

                <h4>Customer Support</h4>
                <p>We believe customer support should be clear, responsive, and handled with care.</p>
                <p>
                  Our customer service team is available seven days a week from 8:00 AM to 10:00 PM UAE Time to assist
                  with orders, delivery updates, payment queries, returns, refunds, warranty support, and general
                  questions.
                </p>
                <p>You can contact us by email or phone:</p>
                <p>Email: {Host?.email}</p>
                <p>Phone:  {Host?.phone}</p>

                <h4>Our Mission</h4>
                <p>
                  Our mission is simple: to help customers find the products they are looking for at competitive prices,
                  deliver them as swiftly as possible, and provide support throughout the shopping experience.
                </p>
                <p>We aim to make every order clear, secure, and convenient from checkout to delivery.</p>

                <h4>Business Information</h4>
                <p style={{ lineHeight: 2 }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: Host?.address,
                    }}
                  ></div>
                  <MailOutlineIcon style={{ fontSize: "18px" }} /> {Host?.email} <br />
                  <PhoneIcon style={{ fontSize: "18px" }} /> {Host?.phone}
                </p>
                <p>Customer Support: 8:00 AM to 10:00 PM UAE Time, 7 days a week</p>
                <p>Website: {window.location.hostname}</p>

                <p>&nbsp;</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutUs;
